<template>
  <BaseDialog
    append-to-body
    width="500px"
    hide-confirm
    @close="handleClose"
  >
    <div class="scanner-dialog__content">
      <p class="text-primary-100 font-bold text-md">請使用條碼槍掃描載具條碼</p>
      <!-- 隱藏的輸入框用於接收掃描器輸入 -->
      <input
        ref="scannerInputRef"
        type="text"
        class="scanner-dialog__hidden-input"
        lang="en"
        inputmode="latin"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        @blur="focusInput"
        @keydown="handleKeyDown"
        @submit.self.prevent
      >
      <img
        src="@/assets/scannerGun/scanner_gun_scan.svg"
        alt="Scanner Gun"
        class="scanner-dialog__image"
      >
    </div>
  </BaseDialog>
</template>

<script>
import { defineComponent, ref, nextTick } from 'vue'
import { useScannerGun } from '@/use/useScannerGun'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'

export default defineComponent({
  name: 'CarrierNumScannerGunDialog',
  components: {
    BaseDialog,
  },
  emits: ['scan', 'close'],
  setup (props, { emit }) {
    const scannerInputRef = ref(null)

    const focusInput = () => {
      nextTick(() => {
        if (scannerInputRef.value) {
          scannerInputRef.value.focus()
        }
      })
    }

    const handleClose = () => {
      clearBuffer()
      emit('close')
    }

    const handleScan = (scannedValue) => {
      emit('scan', scannedValue)
      emit('close')
    }

    const { handleKeyDown, clearBuffer } = useScannerGun({
      onScan: handleScan,
      minLength: 1,
      inputTimeout: 150,
    })

    focusInput()

    return {
      scannerInputRef,
      focusInput,
      handleKeyDown,
      handleClose,
    }
  },
})
</script>

<style lang="postcss" scoped>
.scanner-dialog__content {
  @apply flex flex-col items-center gap-6 py-5 relative;
}

.scanner-dialog__hidden-input {
  @apply absolute top-0 left-0 w-[1px] h-[1px] opacity-0 pointer-events-none z-[-1];
}

.scanner-dialog__image {
  @apply w-[200px] py-[40px];
}
</style>
